import React from 'react'
import { Box } from '@mui/material'
import { initRule, pointText } from '../../../lib/rule'

const Win = ({ simple, rule, label }) => {
  const pt = pointText(simple)

  const point = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {pt}
      </Box>
    </>
  )

  const comprehensivePoint = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        総合{pt}
      </Box>
    </>
  )

  const winPlayers = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        人
      </Box>
    </>
  )

  const above = value => (
    <Box component="span" className="rule-above">
      {value ? '以上' : '以下'}
    </Box>
  )

  const comprehensive = rule.comprehensive || initRule.player.comprehensive
  const specialCorrect = rule.specialCorrect || initRule.player.specialCorrect

  const list = [(
    rule.winPoint.active && !specialCorrect.passQuiz &&
    <Box component="span" className="rule-content" key="win-point">
      {point(rule.winPoint.value)}{above(rule.winPoint.above)}
    </Box>
  ), (
    rule.winPoint.active && specialCorrect.passQuiz &&
    <Box component="span" className="rule-content" key="pass-quiz-point">
      {point(rule.winPoint.value)}{above(rule.winPoint.above)}で通過席, 通過席で正解で勝抜
    </Box>
  ), (
    comprehensive.active && comprehensive.winPoint.active &&
    <Box component="span" className="rule-content" key="win-comp-point">
      {comprehensivePoint(comprehensive.winPoint.value)}{above(comprehensive.winPoint.above)}
    </Box>
  ), (
    rule.winPlayers > 0 &&
    <Box component="span" className="rule-content" key="win-players">
      {winPlayers(rule.winPlayers)}
    </Box>
  )].filter(e => e)

  return list.length > 0 && (
    <Box component="span" className="rule-element">
      <Box component="span" className="rule-title">{label || '勝抜'}</Box>
      {list}
    </Box>
  )
}

export default Win
